import { TextBox } from "@repo/ui";

import type { LayerFilterProps } from "../hooks/useUpdateLayerFilter";

export function EnrollmentIdFilter({ layer, updateFilter }: LayerFilterProps) {
	return (
		<TextBox
			label="Enrollment ID"
			id="enrollmentId"
			type="number"
			inputMode="numeric"
			value={layer.enrollmentId}
			changeHandler={(value: string) => updateFilter(toOptionalInt(value), "enrollmentId")}
		/>
	);
}

function toOptionalInt(value: string) {
	const parsed = parseInt(value, 10);
	return Number.isNaN(parsed) ? undefined : parsed;
}
